import { normalizarCodigo } from './codigoBarras';

// 2026-11-04 (pedido de Milenko): el buscador encontraba solo el texto escrito tal cual y en
// orden ("zapata man" no hallaba "Zapata delantera Man ..."). Ahora busca palabra por palabra,
// en cualquier orden, sin importar tildes, mayúsculas ni espacios dobles.
export function normalizarTexto(s: unknown): string {
  return String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
}

// true si TODAS las palabras de la búsqueda aparecen en alguno de los campos (juntos).
export function coincideBusqueda(busqueda: string, ...campos: unknown[]): boolean {
  const palabras = normalizarTexto(busqueda).split(' ').filter(Boolean);
  if (!palabras.length) return true;
  const texto = normalizarTexto(campos.filter((c) => c != null && c !== '').join(' '));
  return palabras.every((w) => texto.includes(w));
}

// Producto por nombre/código; tolera también el apóstrofo del lector de códigos (ver codigoBarras.ts).
export function coincideProducto(busqueda: string, p: { nombre?: unknown; codigo?: unknown }): boolean {
  if (coincideBusqueda(busqueda, p.nombre, p.codigo)) return true;
  const n = normalizarCodigo(busqueda);
  return n.length > 0 && normalizarCodigo(String(p.codigo ?? '')).includes(n);
}
